const getFlash = state => {
    return state.flash;
};

export default {
    getFlash,
};
